import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './EnrolledCourses.css';
import ProgressBar from '../ProgressBar/ProgressBar';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ClipLoader from 'react-spinners/ClipLoader';
import { useDispatch } from 'react-redux';
import { COURSES_URL, ENROLLMENT_URL } from '../../Services/courseService';

const MyCourses = () => {
  const [myCourses, setMyCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [courseProgress, setCourseProgress] = useState({});
  const navigate = useNavigate();
  const skilltechera_user_id = localStorage.getItem('userId');
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchMyCourses = async () => {
      setLoading(true);
  
      try {
        const enrollmentResponse = await axios.get(`${ENROLLMENT_URL}/${skilltechera_user_id}/enrollments`);
        const courseIds = enrollmentResponse?.data?.map(enrollment => enrollment?.courseId);
        const enrollmentIds = enrollmentResponse?.data?.map(enrollment => enrollment?.id);
  
        if (courseIds?.length > 0) {
          const courseRequests = courseIds?.map(async (courseId) => {
            try {
              const response = await axios.get(`${COURSES_URL}/course/${courseId}`);
              return response?.data;
            } catch (error) {
              console.error(`Error fetching course ${courseId}:`, error);
              return null;
            }
          });
  
          const coursesResponse = await Promise.all(courseRequests);
          const validCourses = coursesResponse.filter(course => course !== null);
          const validEnrollmentIds = enrollmentIds.filter((_, index) => coursesResponse[index] !== null);
  
          setMyCourses(validCourses);
  
          const progressRequests = validEnrollmentIds.map(enrollmentId =>
            axios.get(`${ENROLLMENT_URL}/${enrollmentId}/progress`)
          );
  
          const progressResponses = await Promise.all(progressRequests);
          const progressData = {};
  
          progressResponses?.forEach((response, index) => {
            const courseId = validCourses[index]?.data?.courseId;
            const currentProgress = parseFloat(response?.data?.match(/(\d+(\.\d+)?)/));
  
            if (!isNaN(currentProgress)) {
              progressData[courseId] = currentProgress;
            }
          });
  
          const updatedProgressData = {};
          validCourses.forEach(course => {
            const courseId = course?.data?.courseId;
            updatedProgressData[courseId] = progressData[courseId] || 0;
          });
  
          setCourseProgress(updatedProgressData);
        } else {
          setMyCourses([]);
        }
      } catch (error) {
        console.error('Error fetching enrolled courses:', error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchMyCourses();
  }, [skilltechera_user_id, dispatch]);
  

  const handleClick = (courseId) => {
    navigate(`/enrolledCourse/${courseId}`);
  }

  const { t } = useTranslation();

  return (
    <div className="enrolledCourse-courses-page">
      {
        loading ? ( <ClipLoader color="#333333" loading={loading} size={30} id='clipLoader' /> ) :
        (<>
          <h1 className="enrolledCourse-page-header">{t('EnrolledCourses')}</h1>
          <div className="enrolledCourse-courses-grids">
            {myCourses?.length > 0 ? (
              myCourses?.map((course) => (
                <div 
                  key={course?.data?.courseId} 
                  className="enrolledCourse-course-card" onClick={() => handleClick(course?.data?.courseId)}>
                  <div className="enrolledCourse-course-image">
                    <img 
                      src={course?.data?.imageUrl} 
                      alt={course?.data?.title} 
                    />
                    <h2 className="enrolledCourse-course-title">{course?.data?.title}</h2>
                    <ProgressBar progress={courseProgress[course?.data?.courseId] || 0} /> 
                    {
                      courseProgress[course?.data?.courseId] > 0 ?  
                      <p className='enrolledCourse-course-status'> {courseProgress[course?.data?.courseId]}% {t('Completed')}</p> : ""
                    }
                  </div>
                  <p className="enrolledCourse-start-course" onClick={() => handleClick(course?.data?.courseId)}>
                    {courseProgress[course?.data?.courseId] > 0 ? t('Continue') : t('Start Course')}
                  </p>
                </div>
              ))
            ) : (
              <p className="enrolledCourse-no-courses">{t('NoCoursesEnrolled')}</p>
            )}
          </div>
        </>)

      }
    </div>
  );
};

export default MyCourses;
